/** Username charset from `components/username-input.tsx`. */
const HANDLE = "[a-zA-Z0-9_-]+";

function handlePattern(): RegExp {
  return new RegExp(`(^|[^a-zA-Z0-9_])@(${HANDLE})`, "g");
}

/** @handles in plain text or HTML, ignoring emails (`name@host`). */
export function extractMentionHandles(content: string): string[] {
  if (!content) return [];
  const seen = new Set<string>();
  const handles: string[] = [];
  for (const match of content.matchAll(handlePattern())) {
    const handle = match[2];
    if (!handle) continue;
    const key = handle.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    handles.push(handle);
  }
  return handles;
}

/**
 * Turn @username tokens into profile links.
 * Leaves existing anchors and email addresses alone, and is safe to run once at render time.
 */
export function linkifyMentionHtml(html: string): string {
  if (!html || !html.includes("@")) return html;
  const parts = html.split(/(<[^>]+>)/g);
  let inAnchor = false;
  return parts
    .map((part) => {
      if (part.startsWith("<")) {
        const lower = part.toLowerCase();
        if (lower.startsWith("<a ") || lower.startsWith("<a>")) inAnchor = true;
        else if (lower.startsWith("</a")) inAnchor = false;
        return part;
      }
      if (inAnchor || !part.includes("@")) return part;
      return part.replace(handlePattern(), (_full, prefix: string, username: string) => {
        const href = `/social-profile/${encodeURIComponent(username)}`;
        return `${prefix}<a href="${href}" class="text-blue-600 hover:underline font-medium">@${username}</a>`;
      });
    })
    .join("");
}
